import createReducer from '../utils/createReducer';
import actions from '../actions/actions';
import billingSetupActions from '../actions/billingSetup';
import { merge } from 'lodash';

const initialState = {};
const actionHandlers = {
    [actions.FETCH_INITIAL_DATA_SUCCESS](state, {payload}) {
        const {
            billingPageRedirect,
            isBillingSetupFlow,
            billingSetupMeta,
            vatCountryDetails
        } = payload.response;

        let vatMeta;
        let userMeta;

        if (billingSetupMeta) {
            vatMeta = billingSetupMeta.vat || {};
            userMeta = billingSetupMeta.user || {};
        }

        return {
            ...state,
            billingPageRedirect,
            isBillingSetupFlow,
            vatCountryDetails,
            vatMeta,
            userMeta,
        };
    },

    [billingSetupActions.UPDATE_BILLING_SETUP_META](state, {payload}) {
        return {
            ...state,
            vatMeta: merge(state.vatMeta, payload.vatMeta),
            userMeta: merge(state.userMeta, payload.userMeta),
        };
    },


};

export default createReducer(actionHandlers, initialState);
